<template>
    <div class="w-full bg-white">
        <div v-if="isLoading" class="loading-container">
            <div class="loading">
                <FadeLoader :color="color"/>
            </div>
        </div>
        <div class="min-h-screen bg-white px-2 md:px-6 max-w-7xl mx-auto pb-10 pt-10 md:pt-20">
            <SearchRect class="md:pb-4" />
            <div class="text-center w-full px-6 py-6 text-gray-600 text-base keepall" v-if="this.$route.query.q == ''">
                검색어를 입력하지 않은 경우 랜덤하게 "{{ this.keyword }}"의 검색 결과를 보여드립니다.
            </div>
            <!-- Wide View -->
            <div class="hidden md:flex gap-x-4">
                <SearchResult :model="searchModel" />
                <FacetView :model="facetModel" 
                    @facetData="doFacetSearch" 
                    @columnSearchEvent="doFacetSearch" 
                    @resetPtlEvent="doFacetSearch" 
                    @resetOrgEvent="doFacetSearch" 
                    @resetCateEvent="doFacetSearch"
                    @resetColumnSearchEvent="doFacetSearch" />
            </div>
            <!-- Mobile View -->
            <div class="md:hidden flex flex-col">
                <div class="block md:hidden py-3 px-4 md:px-8 keepall text-center text-base">
                    <span class="text-blue-600 font-medium">{{ this.keyword }}</span>에 대한 검색 결과, 총 <span class="text-blue-600 ibm font-medium">{{ this.searchModel.ptlNum }}</span>개의 포털에서 <span class="text-blue-600 ibm font-medium">{{ this.searchModel.dataNum }}</span>건의 데이터가 검색되었습니다.
                </div>
                <FacetView :model="facetModel" 
                    @facetData="doFacetSearch" 
                    @columnSearchEvent="doFacetSearch" 
                    @resetPtlEvent="doFacetSearch" 
                    @resetOrgEvent="doFacetSearch" 
                    @resetCateEvent="doFacetSearch"
                    @resetColumnSearchEvent="doFacetSearch" />
                <SearchResult :model="searchModel" />
            </div>

            <div class="flex gap-x-4">
                <PaginationView :model="pageDataSetting(total, limit, block, this.page, pageClass, facetData)" 
                    @paging="doSearch" 
                    @facetPaging="doFacetSearch" />
            </div>
        </div>
    </div>
    
</template>
        
        
<script>
import axios from 'axios'
import _debounce from 'lodash/debounce'
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import SearchRect from '@/components/SearchRect.vue'
import SearchResult from '@/components/SearchResult.vue'
import FacetView from '@/components/FacetView.vue'
import PaginationView from '@/components/PaginationView.vue'

export default {
    name: 'SearchView',
    components: {
        SearchRect,
        SearchResult,
        FacetView,
        FadeLoader,
        PaginationView,
    },
    props: [
        "data"
    ],
    data () {
        return {
            query: "",
            keyword: "",
            isLoading: false,
            color: "rgb(148 163 184)",
            // for pagination
            pageClass: "",
            page: 1,
            total: 0,
            limit: 15,
            block: 10,
            // for search result
            searchModel: {
                dataNum: 0,
                ptlNum: 0,
                results: [],
                keyword: "",
                colChkList: [],
            },
            // for facet 
            facetModel: {
                page: 1,
                ptlList: [],
                orgList: [],
                ctList: [],
                colList: [],
            },
            facetData: {},
            columns: []
        }
    },
    async mounted() {
        // Query Results
        this.searchModel.results = await this.doSearch(this.page);
    },
    watch: {
        query: _debounce(async function() {
            this.searchModel.results = await this.doSearch();
        }, 250),
    },
    methods: {
        async doSearch(page) {
            this.isLoading = true;
            
            if (page) {
                this.page = page;
            }
            if (this.$route.query.q == "") {
                this.keyword = "미세먼지"
            } else {
                this.keyword = this.$route.query.q
            }
            const api = "https://labs.datahub.kr/api/v1/datasets/"
            const response = await axios.get(api, {
                withCredentials: true,
                params: {
                    search: this.keyword,
                    limit: this.limit,
                    page: this.page,
                }
            });
            this.searchModel.dataNum = response.data.total_count
            this.searchModel.ptlNum = response.data.portal_total_count
            this.searchModel.results = response.data.data
            this.searchModel.colChkList = new Array(15).fill(false)
            this.facetModel.ptlList = response.data.portal_detail
            this.facetModel.orgList = response.data.org_detail
            this.facetModel.ctList = response.data.category_detail
            this.facetModel.colList = response.data.column_detail
            this.isLoading = false;
            // console.log(response.data)
            // console.log(this.searchModel)
            
            // for pagination
            this.total = response.data.total_count
            this.page = page
            this.pageClass = "ALLPAGE"
            this.pageDataSetting(this.total, this.limit, this.block, page, this.pageClass, null)
            return response.data.data;
        },
        async doFacetSearch(facetData, page) {
            this.isLoading = true;
            this.facetData = facetData
            // console.log("facet 데이터는 ", facetData)
            // console.log("facet 중 column 데이터는 ", facetData.col)
            if (page) {
                this.page = page;
            }
            if (this.$route.query.q == "") {
                this.keyword = "미세먼지"
            } else {
                this.keyword = this.$route.query.q
            }

            const api = "https://labs.datahub.kr/api/v1/facet/"
            const response = await axios.post(api, {
                data: {
                    search: this.keyword,
                    ptl: facetData.ptl,
                    org: facetData.org,
                    cate: facetData.cate,
                    page: this.page,
                    columns: facetData.col,
                }
            });
            this.searchModel.dataNum = response.data.total_count
            this.searchModel.ptlNum = response.data.portal_total_count
            this.searchModel.results = response.data.data
            this.searchModel.colChkList = new Array(15).fill(false)
            this.facetModel.ptlList = response.data.portal_detail
            this.facetModel.orgList = response.data.org_detail
            this.facetModel.ctList = response.data.category_detail
            this.facetModel.colList = response.data.column_detail
            // this.facetModel.colList = facetData.col

            // if (this.facetModel.colChk != true) {
            //     this.facetModel.colList = response.data.column_detail
            // } else {
            //     this.facetModel.colList = facetData.col
            // }
            // console.log("누른 다음의 데이터는 ", this.facetModel.colList)
            // this.facetModel.colList = response.data.column_detail
            this.isLoading = false;
            // console.log("facet 데이터: ", response.data)
            // for pagination
            this.total = response.data.total_count
            this.page = page
            this.pageClass = "FACETPAGE"
            this.pageDataSetting(this.total, this.limit, this.block, page, this.pageClass, this.facetData)
            return response.data.data
        },
        pageDataSetting(total, limit, block, page, pageClass, facetData) {
            const totalPage = Math.ceil(total / limit)
            let currentPage = page
            const first = currentPage > 1 ? parseInt(currentPage, 10) - parseInt(1, 10) : null
            const end = totalPage !== currentPage ? parseInt(currentPage, 10) + parseInt(1, 10) : null
            let startIndex = (Math.ceil(currentPage / block) - 1) * block + 1
            let endIndex = startIndex + block > totalPage ? totalPage : startIndex + block - 1
            let list = []
            for (let i = startIndex; i <= endIndex; i++) {
                list.push(i)
            }
            // console.log({first, end, list, totalPage, currentPage, pageClass, facetData})
            return { first, end, list, totalPage, currentPage, pageClass, facetData }
        }
        
    },
}
</script>
    
<style scoped>
.loading {
    z-index: 2;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 9999px;
}

.keepall{
    word-break: keep-all;
}
</style>